@use 'styles/utils/variables' as *;

div.ant-typography {
  color: $text-color-primary;
  font-weight: normal;

  &.strong {
    font-weight: 600;
  }

  // A paragraph runs over several lines (notes, comments): its line height follows the text size,
  // a fixed 16px packed the lines once the base size grew past 14px.
  &.small {
    font-size: var(--fontSize-base);
    line-height: 1.5;
  }

  &.middle {
    font-size: var(--fontSize-base);
    line-height: 1.5;
  }

  &.large {
    font-size: 1.6rem;
    line-height: 1.8rem;
  }

  &.ant-typography-secondary {
    color: $text-color-secondary-dark;
  }

  &.ant-typography-success {
    color: $text-on-tint-success;
  }

  &.ant-typography-warning {
    color: $text-on-tint-warning;
  }

  &.ant-typography-danger {
    color: $text-on-tint-danger;
  }
}
